import { gql } from '@grandvisionhq/graphql';

var StoreInventoryFragment = gql`
  fragment StoreInventory on Store {
    inventory(sku: $sku) {
      sku
      totalQuantity
      stockIndicator
      items {
        showroomModelAvailable
      }
    }
  }
`;

export { StoreInventoryFragment as default };
//# sourceMappingURL=store-inventory.js.map
